import React from 'react';
import { Button, Dropdown, Form, Popup, Table, TextArea } from 'semantic-ui-react';
import { number } from 'prop-types';

const ThreeColumnTableRow = (props) => (
    props.twoCol ?
        <Table.Row>
            <Table.Cell
                colSpan={1}
                textAlign="right"
                verticalAlign="middle"
            >
                <b>{props.name}</b>
            </Table.Cell>
            <Table.Cell
                colSpan={2}
                verticalAlign="middle"
            >
                {props.value}
            </Table.Cell>

        </Table.Row> :
        props.oneCol ?
            props.icon ?
                <Table.Row>
                    <Table.Cell
                        colSpan={2}
                        textAlign="center"
                        verticalAlign="middle"
                    >
                        <Popup
                            content="Izmjena"
                            position="top center"
                            trigger={

                                <Button
                                    basic="true"
                                    circular
                                    icon="pencil"
                                    size="tiny"
                                    color="blue"
                                    disabled={props.disabled}
                                    onClick={props.onClick}
                                />

                            }
                        />
                        {/* <Icon */}
                        {/*    link */}
                        {/*    circular */}
                        {/*    color="blue" */}
                        {/*    floated="right" */}
                        {/*    name="pencil" */}
                        {/*    disabled={props.disabled} */}
                        {/*    onClick={props.onClick} */}
                        {/* /> */}
                    </Table.Cell>

                </Table.Row>
                : <Table.Row>
                    <Table.Cell
                        style={{ background: '#F5F4F4' }}
                        colSpan={2}
                        textAlign="center"
                        verticalAlign="middle"
                    >
                        <b>{props.name}</b>
                    </Table.Cell>

                </Table.Row>
            :
                <Table.Row>
                <Table.Cell textAlign="right" verticalAlign="middle">
                        <b>{props.name}</b>
                    </Table.Cell>
                <Table.Cell verticalAlign="middle">
                        {props.value}
                    </Table.Cell>
                {(props.edit && props.keyName === 'studyType') ? <Table.Cell verticalAlign="middle">
                        <Form>
                        <Form.Field >
                                <Dropdown
                                clearable
                                defaultValue={props.defValue}
                                placeholder="Odaberite tip studiranja"
                                value={props.input}
                                onChange={props.onChange}
                                name={props.keyName}
                                options={props.studyTypes}
                                compact
                                selection
                            />
                            </Form.Field>
                    </Form>
                    </Table.Cell>
                    : (props.edit && props.keyName === 'studyCycle') ? <Table.Cell verticalAlign="middle">
                        <Form>
                            <Form.Field>
                                <Dropdown
                                    clearable
                                    defaultValue={props.defValue}
                                    placeholder="Odaberite studijski ciklus"
                                    value={props.input}
                                    onChange={props.onChange}
                                    name={props.keyName}
                                    options={props.studyCycles}
                                    compact
                                    selection
                                    search
                                />
                            </Form.Field>
                        </Form>
                    </Table.Cell>
                        : (props.edit && props.keyName === 'countrieResidence') ? <Table.Cell verticalAlign="middle">
                            <Form>
                                <Form.Field>
                                    <Dropdown
                                        clearable
                                        defaultValue={props.defValue}
                                        placeholder="Odaberite državu"
                                        value={props.input}
                                        onChange={props.onChange}
                                        name={props.keyName}
                                        options={props.countries}
                                        compact
                                        selection
                                        search
                                    />
                                </Form.Field>
                            </Form>
                        </Table.Cell>
                            : (props.edit && props.keyName === 'entityResidence') ? <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Field disabled={props.disabled}>
                                        <Dropdown
                                            clearable
                                            defaultValue={props.defValue}
                                            placeholder="Odaberite enitet"
                                            value={props.input}
                                            onChange={props.onChange}
                                            name={props.keyName}
                                            options={props.entities}
                                            compact
                                            selection
                                            search
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                                : (props.edit && props.keyName === 'cantonResidence') ? <Table.Cell verticalAlign="middle">
                                    <Form>
                                        <Form.Field disabled={props.disabled}>
                                            <Dropdown
                                                clearable
                                                defaultValue={props.defValue}
                                                placeholder="Odaberite kanton"
                                                value={props.input}
                                                onChange={props.onChange}
                                                name={props.keyName}
                                                options={props.cantons}
                                                compact
                                                selection
                                                search
                                            />
                                        </Form.Field>
                                    </Form>
                                </Table.Cell>
                                    : (props.edit && props.keyName === 'municipalityResidence') ? <Table.Cell verticalAlign="middle">
                                        <Form>
                                            <Form.Field disabled={props.disabled}>
                                                <Dropdown
                                                    clearable
                                                    defaultValue={props.defValue}
                                                    placeholder="Odaberite općinu"
                                                    value={props.input}
                                                    onChange={props.onChange}
                                                    name={props.keyName}
                                                    options={props.municipalities}
                                                    compact
                                                    selection
                                                    search
                                                />
                                            </Form.Field>
                                        </Form>
                                    </Table.Cell>
                                        : (props.edit && props.keyName === 'citizenship') ? <Table.Cell verticalAlign="middle">
                                            <Form>
                                                <Form.Field disabled={props.disabled}>
                                                    <Dropdown
                                                        clearable
                                                        defaultValue={props.defValue}
                                                        placeholder="Odaberite državljastvo(a)"
                                                        value={props.input}
                                                        onChange={props.onChange}
                                                        name={props.keyName}
                                                        options={props.citizenships}
                                                        selection
                                                        search
                                                        multiple
                                                    />
                                                </Form.Field>
                                            </Form>
                                        </Table.Cell>
                                            : (props.edit && props.keyName === 'languages') ? <Table.Cell verticalAlign="middle">
                                                <Form>
                                                    <Form.Field >
                                                        <Dropdown
                                                            clearable
                                                            defaultValue={props.defValue}
                                                            placeholder="Odaberite jezike"
                                                            value={props.input}
                                                            onChange={props.onChange}
                                                            name={props.keyName}
                                                            options={props.languages}
                                                            compact
                                                            selection
                                                            search
                                                        />
                                                    </Form.Field>
                                                </Form>
                                            </Table.Cell>
                                                : (props.edit && props.keyName === 'studyProgramOrganizationalUnits') ? <Table.Cell verticalAlign="middle">
                                                    <Form>
                                                        <Form.Field >
                                                            <Dropdown
                                                                clearable
                                                                defaultValue={props.defValue}
                                                                placeholder="Odaberite organizacione jedinice"
                                                                value={props.input}
                                                                onChange={props.onChange}
                                                                name={props.keyName}
                                                                options={props.organizationalUnits}
                                                                compact
                                                                selection
                                                                search
                                                                multiple
                                                            />
                                                        </Form.Field>
                                                    </Form>
                                                </Table.Cell>
                                                    : (props.edit && props.keyName === 'academicYearStart') ? <Table.Cell verticalAlign="middle">
                                                        <Form>
                                                            <Form.Field >
                                                                <Dropdown
                                                                    clearable
                                                                    defaultValue={props.defValue}
                                                                    placeholder="Odaberite akademsku godinu početka"
                                                                    value={props.input}
                                                                    onChange={props.onChange}
                                                                    name={props.keyName}
                                                                    options={props.academicYears}
                                                                    compact
                                                                    selection
                                                                    search
                                                                />
                                                            </Form.Field>
                                                        </Form>
                                                    </Table.Cell>
                                                        : (props.edit && props.keyName === 'occupationStatus') ? <Table.Cell verticalAlign="middle">
                                                            <Form>
                                                                <Form.Field >
                                                                    <Dropdown
                                                                        clearable
                                                                        defaultValue={props.defValue}
                                                                        placeholder="Odaberite status u zanimanju"
                                                                        value={props.input}
                                                                        onChange={props.onChange}
                                                                        name={props.keyName}
                                                                        options={props.occupationStatuses}
                                                                        compact
                                                                        selection
                                                                        search
                                                                    />
                                                                </Form.Field>
                                                            </Form>
                                                        </Table.Cell>
                                                            : (props.edit && props.keyName === 'newEducationLevel') ? <Table.Cell verticalAlign="middle">
                                                                <Form>
                                                                    <Form.Field >
                                                                        <Dropdown
                                                                            clearable
                                                                            defaultValue={props.defValue}
                                                                            placeholder="Nivo obrazovanja"
                                                                            value={props.input}
                                                                            onChange={props.onChange}
                                                                            name={props.keyName}
                                                                            options={props.educationLevels}
                                                                            compact
                                                                            selection
                                                                            search
                                                                        />
                                                                    </Form.Field>
                                                                </Form>
                                                            </Table.Cell>
                                                                : (props.edit && props.keyName === 'activityStatus') ? <Table.Cell verticalAlign="middle">
                                                                    <Form>
                                                                        <Form.Field >
                                                                            <Dropdown
                                                                                clearable
                                                                                defaultValue={props.defValue}
                                                                                placeholder="Odaberite status u aktivnosti"
                                                                                value={props.input}
                                                                                onChange={props.onChange}
                                                                                name={props.keyName}
                                                                                options={props.activityStatusTypes}
                                                                                compact
                                                                                selection
                                                                                search
                                                                            />
                                                                        </Form.Field>
                                                                    </Form>
                                                                </Table.Cell>
                                                                    : (props.edit && props.keyName === 'titleName') ? <Table.Cell verticalAlign="middle">
                                                                            <Form>
                                                                                <Form.Field >
                                                                                    <Dropdown
                                                                                        clearable
                                                                                    defaultValue={props.defValue}
                                                                                    placeholder="Odaberite titulu"
                                                                                    value={props.input}
                                                                                    onChange={props.onChange}
                                                                                    name={props.keyName}
                                                                                    options={props.titles}
                                                                                    compact
                                                                                    selection
                                                                                    search
                                                                                    />
                                                                                </Form.Field>
                                                                            </Form>
                                                                        </Table.Cell>
                                                                    : props.edit ? <Table.Cell verticalAlign="middle">
                                                                        <Form>
                                                                            {props.textArea ? <TextArea
                                                                                style={{ minHeight: props.keyName === 'studyOutcomes' ? 400 : 150 }}
                                                                                defaultValue={props.defValue}
                                                                                value={props.input}
                                                                                onChange={(e) => props.onChange(props.keyName, e.target.value)}
                                                                                name="input"
                                                                                placeholder="Unesite novi podatak"
                                                                            />
                                                                                : <Form.Field disabled={props.disabled}>
                                                                                    <input
                                                                                        defaultValue={props.defValue}
                                                                                        value={props.input}
                                                                                        onChange={(e) => props.onChange(props.keyName, e.target.value)}
                                                                                        name="input"
                                                                                        placeholder="Unesite novi podatak"
                                                                                    />
                                                                                </Form.Field>}
                                                                        </Form>
                                                                    </Table.Cell>
                                                                        : ''}
            </Table.Row>
);
export default ThreeColumnTableRow;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/ThreeColumnTableRow.js